'use strict';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||!1;descriptor.configurable=!0;if('value'in descriptor)descriptor.writable=!0;Object.defineProperty(target,descriptor.key,descriptor)}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor}}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError('Cannot call a class as a function')}}

const _=require('pulsar-utils/dist-es6/_');
const ThresholdStatus=require('pulsar-dashboard-core/dist-es6/domain/thresholdStatus');
const NotificationType=require('pulsar-dashboard-core/dist-es6/domain/notificationType');
const AlertStatusCache=require('../../../dist-es6/client/viewModels/alertStatusCache');let

GroupStatisticsViewModel=function(){
function GroupStatisticsViewModel(
id,
name,
aggregatePersons,
directPersons,
numTripsOnDuty,
numPersonsOnDuty,
maxFatigueOnDuty,
maxLastKnownFatigue,
averageHoursOfSleepPerDay,
averageFatigueOnDuty,
fatigueThreshold,
deviationThreshold)

{var _this=this;let percentOverThresholdCache=arguments.length>12&&arguments[12]!==void 0?arguments[12]:void 0;let isSpecialGroupContainingWholeOrg=arguments.length>13&&arguments[13]!==void 0?arguments[13]:!1;_classCallCheck(this,GroupStatisticsViewModel);

_.ensureInstanceOf('number',fatigueThreshold);
_.ensureInstanceOf('number',deviationThreshold);
if(deviationThreshold<1||deviationThreshold>3){
throw new Error(`Unexpected deviationThreshold: ${deviationThreshold}`);
}

this._id=id;
this._name=name;
this._aggregatePersons=aggregatePersons;
this._directPersons=directPersons;
this._numTripsOnDuty=numTripsOnDuty;
this._numPersonsOnDuty=numPersonsOnDuty;
this._maxFatigueOnDuty=maxFatigueOnDuty;
this._maxLastKnownFatigue=maxLastKnownFatigue;
this._averageHoursOfSleepPerDay=averageHoursOfSleepPerDay;
this._averageFatigueOnDuty=averageFatigueOnDuty;
this._fatigueThreshold=fatigueThreshold;
this._deviationThreshold=deviationThreshold;
this._isSpecialGroupContainingWholeOrg=isSpecialGroupContainingWholeOrg;

if(this._isSpecialGroupContainingWholeOrg){
this.children=[];
}

this._percentOverThresholdCache=percentOverThresholdCache||new AlertStatusCache(function(nt){return _this._percentOverThreshold(nt)});
}GroupStatisticsViewModel.prototype.













































































percentOverThreshold=function percentOverThreshold(notificationType){
return this._percentOverThresholdCache.get(notificationType);
};GroupStatisticsViewModel.prototype.

_percentOverThreshold=function _percentOverThreshold(notificationType){
_.ensureInstanceOf(NotificationType,notificationType);

const numAggregatePersons=this.aggregatePersons.length;
const numOverThreshold=this.aggregatePersons.
filter(function(person){return person.thresholdStatusFor(notificationType)===ThresholdStatus.Above}).
length;

if(numAggregatePersons===0){
return'--';
}

return`${Math.ceil(numOverThreshold/numAggregatePersons*100)}%`;
};_createClass(GroupStatisticsViewModel,[{key:'id',get:function(){return this._id}},{key:'name',get:function(){return this._name}},{key:'aggregatePersons',get:function(){return this._aggregatePersons}},{key:'directPersons',get:function(){return this._directPersons}},{key:'numTripsOnDuty',get:function(){return this._numTripsOnDuty}},{key:'numPersonsOnDuty',get:function(){return this._numPersonsOnDuty}},{key:'maxFatigueOnDuty',get:function(){return this._maxFatigueOnDuty}},{key:'maxLastKnownFatigue',get:function(){return this._maxLastKnownFatigue}},{key:'maxFatigueForHeader',get:function(){return this._maxFatigueForHeader},set:function(maxFatigueForHeader){this._maxFatigueForHeader=maxFatigueForHeader}},{key:'averageHoursOfSleepPerDay',get:function(){return this._averageHoursOfSleepPerDay}},{key:'averageFatigueOnDuty',get:function(){return this._averageFatigueOnDuty}},{key:'children',set:function(children){if(_.exists(this._children)){throw new Error('children can only be set once')}_.ensureInstanceOf(Array,children);children.forEach(function(c){return _.ensureInstanceOf(GroupStatisticsViewModel,c)});this._children=children},get:function(){return this._children}},{key:'isSpecialGroupContainingWholeOrg',get:function(){return this._isSpecialGroupContainingWholeOrg}},{key:'fatigueThreshold',get:function(){return this._fatigueThreshold}},{key:'deviationThreshold',get:function(){return this._deviationThreshold}}]);return GroupStatisticsViewModel}();


module.exports=GroupStatisticsViewModel;
//# sourceMappingURL=groupStatisticsViewModel.js.map
